export default __webpack_public_path__ + "static/media/btns.sprite.301278bd77e8b866e8ab83d5b6460bf8.svg";